import { API, unpackEndpoint } from "@brg/api";

const endpoint = unpackEndpoint({
    develop: 'https://api.burgdev.ru/ftbl',
    staging: 'https://api.burgstg.ru/ftbl',
    production: 'https://api.mediiia.ru/ftbl',
    hseOnline: 'https://api.hsedesign.online/ftbl',
})

export function ftblApi() {
    return {
        getChamps() {
            let url = '/api/soccer/gameschedules/champs';

            return API.request()
                .endpoint(endpoint)
                .url(url)
                .get()
                .send()
                .then(res => res.json())
        },

        getGamesSchedule({ date, champId }: { date?: string; champId?: number | null }) {
            let url = '/api/soccer/gameschedules/byday';
            if (date) url = `${url}/${date}`;
            const request = API
                .request()
                .endpoint(endpoint)
                .url(url);
            if (champId) request.addQuery('champId', champId);

            return request
                .get()
                .send()
                .then(res => res.json())
        },

        getUserPeriods() {
            let url = '/api/predictor/results/users/periods';

            return API.request()
                .endpoint(endpoint)
                .url(url)
                .get()
                .send()
                .then(res => res.json())
        },

        getUserResultsTableByDate({ date }: { date: string }) {
            let url = `/api/predictor/results/users/${date}`;

            return API.request()
                .endpoint(endpoint)
                .url(url)
                .get()
                .send()
                .then(res => res.json())
        },

        getPredictions({ accountId, page = 1, limit = 10 }: { accountId: string; page?: number; limit?: number }) {
            return API.request()
                .endpoint(endpoint)
                .url('/api/predictor/predictions')
                .addQuery('accountId', accountId)
                .addQuery('page', page)
                .addQuery('limit', limit)
                .get()
                .send()
                .then(res => res.json())
        },

        getPredictionsInfoByScheduleIds({ gameScheduleIds }: { gameScheduleIds: string[] }) {
            let url = '/api/predictor/predictions/info';

            return API.request()
                .endpoint(endpoint)
                .url(url)
                .addQuery('gameScheduleIds', gameScheduleIds.join(','))
                .get()
                .send()
                .then(res => res.json())
        },

        getTeamPeriods() {
            let url = '/api/predictor/results/fantasyteams/periods';

            return API.request()
                .endpoint(endpoint)
                .url(url)
                .get()
                .send()
                .then(res => res.json())
        },

        getTeamResultsTableByDate({ date }: { date: string }) {
            let url = `/api/predictor/results/fantasyteams/${date}`;

            return API.request()
                .endpoint(endpoint)
                .url(url)
                .get()
                .send()
                .then(res => res.json())
        },
    }
}
import { API, unpackEndpoint } from "@brg/api";

const endpoint = unpackEndpoint({
    develop: 'https://api.burgdev.ru/ftbl',
    staging: 'https://api.burgstg.ru/ftbl',
    production: 'https://api.mediiia.ru/ftbl',
    hseOnline: 'https://api.hsedesign.online/ftbl',
})

export function ftblApi() {
    return {
        getChamps() {
            let url = '/api/soccer/gameschedules/champs';

            return API.request()
                .endpoint(endpoint)
                .url(url)
                .get()
                .send()
                .then(res => res.json())
        },

        getGamesSchedule({ date, champId }: { date?: string; champId?: number | null }) {
            let url = '/api/soccer/gameschedules/byday';
            if (date) url = `${url}/${date}`;
            const request = API
                .request()
                .endpoint(endpoint)
                .url(url);
            if (champId) request.addQuery('champId', champId);

            return request
                .get()
                .send()
                .then(res => res.json())
        },

        getUserPeriods() {
            let url = '/api/predictor/results/users/periods';

            return API.request()
                .endpoint(endpoint)
                .url(url)
                .get()
                .send()
                .then(res => res.json())
        },

        getUserResultsTableByDate({ date }: { date: string }) {
            let url = `/api/predictor/results/users/${date}`;

            return API.request()
                .endpoint(endpoint)
                .url(url)
                .get()
                .send()
                .then(res => res.json())
        },

        getPredictions({ accountId, page = 1, limit = 10 }: { accountId: string; page?: number; limit?: number }) {
            return API.request()
                .endpoint(endpoint)
                .url('/api/predictor/predictions')
                .addQuery('accountId', accountId)
                .addQuery('page', page)
                .addQuery('limit', limit)
                .get()
                .send()
                .then(res => res.json())
        },

        getPredictionsInfoByScheduleIds({ gameScheduleIds }: { gameScheduleIds: string[] }) {
            let url = '/api/predictor/predictions/info';

            return API.request()
                .endpoint(endpoint)
                .url(url)
                .addQuery('gameScheduleIds', gameScheduleIds.join(','))
                .get()
                .send()
                .then(res => res.json())
        },

        getTeamPeriods() {
            let url = '/api/predictor/results/fantasyteams/periods';

            return API.request()
                .endpoint(endpoint)
                .url(url)
                .get()
                .send()
                .then(res => res.json())
        },

        getTeamResultsTableByDate({ date }: { date: string }) {
            let url = `/api/predictor/results/fantasyteams/${date}`;

            return API.request()
                .endpoint(endpoint)
                .url(url)
                .get()
                .send()
                .then(res => res.json())
        },
    }
}
